import React, { useState } from "react";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { Link } from "react-router-dom";

const StyledMenu = withStyles((theme) => ({
  paper: {
    backgroundColor: "white",
    boxShadow: "0.3px 0.3px 2.5px 0.3px grey",
    margin: "0px",
  },
}))((props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "center",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "center",
    }}
    {...props}
  />
));

const StyledMenuItem = withStyles((theme) => ({
  root: {
    "&:hover": {},
    "&:focus": {
      backgroundColor: theme.palette.default,
      "& .MuiListItemText-primary": {
        color: "white",
      },
    },
  },
}))(MenuItem);

export default function TextDropdown({ title, subitems, color }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const handleClick = (event) => {
    if (!isOpen) {
      setAnchorEl(event.currentTarget);
      setIsOpen(true);
    } else {
      handleClose();
    }
  };

  const handleClose = () => {
    setIsOpen(false);
    setAnchorEl(null);
  };

  return (
    <div className="menu">
      {title && (
        <Button
          aria-controls="customized-menu"
          aria-haspopup="true"
          variant="text"
          onClick={handleClick}
          color={color}
        >
          {title}
          {/* <ExpandMoreIcon /> */}
        </Button>
      )}
      <StyledMenu
        id="customized-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {subitems.map((item, i) => (
          <Link onClick={handleClose} key={i} to={item.to}>
            <StyledMenuItem>
              <span className="menu__menuItem">{item.label}</span>
            </StyledMenuItem>
          </Link>
        ))}
      </StyledMenu>
    </div>
  );
}
